import { render, staticRenderFns } from "./verify_phone.vue?vue&type=template&id=3c8f0854&scoped=true&"
import script from "./verify_phone.vue?vue&type=script&lang=js&"
export * from "./verify_phone.vue?vue&type=script&lang=js&"
import style0 from "./verify_phone.vue?vue&type=style&index=0&id=3c8f0854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f0854",
  null
  
)

export default component.exports